var map = {
	"./music-instructions.json": 3040,
	"./music-library-intro2024.json": 3041,
	"./music-library-launch2024.json": 3042,
	"./music-progression.json": 3043,
	"./startSourcesAdvanced.json": 3044,
	"./startSourcesSimple.json": 3045,
	"./startSourcesSimple2.json": 3046,
	"./startSourcesTracks.json": 3047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2827;